import queryString from "query-string"
import { useState, useEffect } from "react"
import { useHistory, useLocation } from "react-router-dom"

import Box from "@material-ui/core/Box"
import TableSortLabel from "@material-ui/core/TableSortLabel"

import { queryStringify } from "common/helpers/admin-page-func.helper"
import { HelpTooltip } from "components/widgets"

const AdminHeaderForm = props => {
    const { label, children, SortProps, tooltip } = props
    const { key, ...TableSortLabelProps } = SortProps

    const history = useHistory()
    const location = useLocation()
    const [sort, setSort] = useState({})

    useEffect(() => {
        setSort(queryString.parse(location.search))
    }, [location.search])

    function onClickSort() {
        const newSort = { sortBy: key, sortDir: getNextSortDir(sort.sortDir) }
        const search = queryStringify({
            ...queryString.parse(location.search),
            ...newSort
        })
        history.push({ search })
    }

    return (
        <Box display="flex" flexDirection="column" alignItems="flex-start">
            <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                width="100%"
            >
                <TableSortLabel
                    {...TableSortLabelProps}
                    disabled={typeof key !== "string"}
                    style={{
                        flexDirection: "row"
                    }}
                    {...(typeof key === "string" && {
                        active: sort.sortBy === key,
                        direction: sort.sortDir,
                        onClick: onClickSort
                    })}
                >
                    {label}
                </TableSortLabel>
                {tooltip && <HelpTooltip title={tooltip} />}
            </Box>
            <Box flexGrow={1} width="100%">
                {children}
            </Box>
        </Box>
    )
}

function getNextSortDir(dir) {
    if (dir === undefined || dir === "desc") return "asc"
    return "desc"
}

export default AdminHeaderForm
